/* eslint-disable react/prop-types */

const NumButton = ({ onClick, value, colorClass = "", className = "" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        w-16 h-16 sm:w-[72px] sm:h-[72px] rounded-2xl
        flex items-center justify-center 
        text-2xl font-bold font-mono select-none cursor-pointer
        backdrop-blur-sm transition-all duration-150
        active:scale-95 shadow-sm
        ${colorClass}
        ${className}
      `}
    >
      <span>{value}</span>
    </button>
  );
};

export default NumButton;
